import QuizService from "services/quizService";

const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");


export const getQuizzes = createAsyncThunk(
  "quizzes/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await QuizService.getQuizzes();
      // According to backend controller, data is { status: "success", data: { quizzes } }
      return response.data?.data?.quizzes || response.data?.quizzes || response.data?.data; 
    } catch (error) {
      return rejectWithValue(error.response || "Internal server error");
    }
  }
);

export const getQuiz = createAsyncThunk(
  "quizzes/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await QuizService.getQuiz(id);
      return response.data?.data?.quiz || response.data?.quiz || response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response || "Internal server error");
    }
  }
);

export const createQuiz = createAsyncThunk(
  "quizzes/create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await QuizService.createQuiz(data);
      return response.data?.data?.quiz || response.data?.quiz || response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response || "Internal server error");
    }
  }
);

export const updateQuiz = createAsyncThunk(
  "quizzes/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await QuizService.updateQuiz(id, data);
      return response.data?.data?.quiz || response.data?.quiz || response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response || "Internal server error");
    }
  }
);

export const deleteQuiz = createAsyncThunk(
  "quizzes/delete",
  async (id, { rejectWithValue }) => {
    try {
      await QuizService.deleteQuiz(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response || "Internal server error");
    }
  }
);

const initialState = {
  quizzes: [],
  quiz: null,
  loading: false,
  error: null,
  success: false,
};

const quizzesSlice = createSlice({
  name: "quizzes",
  initialState,
  reducers: {
    clearSuccess: (state) => {
      state.success = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // getQuizzes
      .addCase(getQuizzes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuizzes.fulfilled, (state, action) => {
        state.loading = false;
        state.quizzes = action.payload;
        state.error = null;
      })
      .addCase(getQuizzes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // getQuiz
      .addCase(getQuiz.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuiz.fulfilled, (state, action) => {
        state.loading = false;
        state.quiz = action.payload;
        state.error = null;
      })
      .addCase(getQuiz.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // createQuiz
      .addCase(createQuiz.pending, (state) => {
        state.loading = true;
      })
      .addCase(createQuiz.fulfilled, (state, action) => {
        state.loading = false;
        state.quizzes.push(action.payload);
        state.success = true;
        state.error = null;
      })
      .addCase(createQuiz.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // updateQuiz
      .addCase(updateQuiz.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateQuiz.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.quizzes.findIndex((q) => q._id === action.payload._id);
        if (index !== -1) {
          state.quizzes[index] = action.payload;
        }
        state.success = true;
        state.error = null;
      })
      .addCase(updateQuiz.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // deleteQuiz
      .addCase(deleteQuiz.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteQuiz.fulfilled, (state, action) => {
        state.loading = false;
        state.quizzes = state.quizzes.filter((q) => q._id !== action.payload);
        state.success = true;
        state.error = null;
      })
      .addCase(deleteQuiz.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSuccess, clearError } = quizzesSlice.actions;
export default quizzesSlice.reducer;
